import React from 'react'
import {Snackbar} from "@material-ui/core";
import MuiAlert from '@material-ui/lab/Alert';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

export const SnackBarAlert =
    ({
         open,
         handleClose,
         message = '',
         messageType = 'success',
         autoHideDuration = 60000,
     }) => (
        <Snackbar open={open} autoHideDuration={autoHideDuration}
                  onClose={handleClose}>
            <Alert severity={messageType}
                   onClose={handleClose}>
                {message}
            </Alert>
        </Snackbar>
    );
